import React from 'react';
import PropTypes from "prop-types";
import {useSearchParams} from "react-router-dom";

const ColumnSelector = function (
    {
        index,
        column_key,
        columns,
        selectedColumns,
        query_divider = '~'
    }
) {
    const [searchParams, setSearchParams] = useSearchParams();

    return (
        <select
            className='filter-column-selector'
            value={column_key}
            onChange={event => {
                const column = columns.find(col => col.key === event.target.value);
                searchParams.set('column' + query_divider + index, column.key);
                searchParams.set('expression' + query_divider + index, column.expressions[0]);
                searchParams.set('value' + query_divider + index, column.default ? column.default : '');
                setSearchParams(searchParams);
            }}
        >
            {columns.map(column => {
                return <option
                    key={column.key}
                    value={column.key}
                    disabled={selectedColumns.indexOf(column.key) >= 0 && column.hasOwnProperty('multiple') && column.multiple === false}
                >{column.name}</option>
            })}
        </select>
    );
}

ColumnSelector.propTypes = {
    index: PropTypes.number.isRequired,
    column_key: PropTypes.string.isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        expressions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
        multiple: PropTypes.bool,
        component: PropTypes.func
    })).isRequired,
    selectedColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
    query_divider: PropTypes.string
};

export default ColumnSelector;
